import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingNav from '../components/LandingNav';
import { BLOG_POSTS } from '../config/blog-posts';
import '../styles/blog.css';

export default function BlogPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <LandingNav solid />

      <main className="blog-container">
        <header className="blog-header">
          <h1 className="blog-title">Blog</h1>
          <p className="blog-subtitle">
            Case studies, insights, and playbooks on employee-generated content (EGC) — and how modern brands can build a
            content advantage that compounds.
          </p>
          <div className="blog-header-actions">
            <button className="blog-btn primary" onClick={() => navigate('/contact')}>
              Contact
            </button>
            <button className="blog-btn secondary" onClick={() => navigate('/login')}>
              Log In
            </button>
          </div>
        </header>

        <section className="blog-list" aria-label="Blog posts">
          {BLOG_POSTS.map((post) => (
            <div
              key={post.slug}
              className="blog-card"
              role="button"
              tabIndex={0}
              onClick={() => navigate(`/blog/${post.slug}`)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigate(`/blog/${post.slug}`);
              }}
            >
              <div className="blog-card-top">
                {post.logoSrc ? (
                  <div className="blog-card-logo">
                    <img src={post.logoSrc} alt={post.logoAlt || post.brand || 'Brand'} />
                  </div>
                ) : (
                  <div className="blog-card-logo" aria-hidden="true" />
                )}
                <div className="blog-card-chip">{post.brand ? `${post.brand} Case Study` : 'Blog'}</div>
              </div>
              <div className="blog-card-body">
                <h2 className="blog-card-title">{post.title}</h2>
                <p className="blog-card-excerpt">{post.excerpt}</p>
              </div>
              <div className="blog-card-footer">
                <span>{post.dateLabel || ' '}</span>
                <span className="blog-card-link">Read →</span>
              </div>
            </div>
          ))}
        </section>
      </main>
    </div>
  );
}

